var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDraftOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11H19C19.5439 11 20 10.5439 20 10C20 9.45614 19.5439 9 19 9H12C11.4561 9 11 9.45614 11 10C11 10.5439 11.4561 11 12 11ZM12 2H8C5.78947 2 4 3.78947 4 6V18C4 20.2105 5.78947 22 8 22H16C18.2105 22 20 20.2105 20 18V10C20 9.45614 19.5439 9 19 9C18.4561 9 18 9.45614 18 10V18C18 19.2281 17.2281 20 16 20H8C6.77193 20 6 19.2281 6 18V6C6 4.77193 6.77193 4 8 4H12C12.5439 4 13 3.54386 13 3C13 2.45614 12.5439 2 12 2ZM11 3V10C11 10.5439 11.4561 11 12 11C12.5439 11 13 10.5439 13 10V3C13 2.45614 12.5439 2 12 2C11.4561 2 11 2.45614 11 3ZM19.7018 9.29825L12.7018 2.29825C12.5263 2.10526 12.2807 2 12 2C11.4561 2 11 2.45614 11 3C11 3.2807 11.1053 3.52632 11.2982 3.70176L18.2982 10.7018C18.4737 10.8947 18.7193 11 19 11C19.5439 11 20 10.5439 20 10C20 9.7193 19.8947 9.47368 19.7018 9.29825Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftOutlined);
export default __webpack_public_path__ + "static/media/draft_outlined.3c5acb45.svg";
export { ForwardRef as ReactComponent };